import { purposes, type Component, type Purpose } from '@/api/core/native-presentation';

export type CategoryId =
  | 'basic'
  | 'address'
  | 'cardLabel'
  | 'notice'
  | 'common'
  | 'location'
  | 'floor'
  | 'etc';

export const CATEGORY_TITLE: Record<CategoryId, string> = {
  basic: '기본 정보',
  address: '주소·지역·건물',
  cardLabel: '카드 표시 라벨',
  notice: '안내',
  common: '공용공간',
  location: '위치·교통',
  floor: '층별 안내',
  etc: '기타',
};
export const CATEGORY_ORDER = Object.keys(CATEGORY_TITLE) as CategoryId[];

/** 문구 용도 → 범주. 목록에 없는 용도는 "기타"로 보내 화면에서 사라지지 않게 한다. */
export const PURPOSE_CATEGORY: Partial<Record<Purpose, CategoryId>> = {
  DISPLAY_NAME: 'basic',
  FULL_NAME: 'basic',
  BRAND_NAME: 'basic',
  TAGLINE: 'basic',
  CARD_DESCRIPTION: 'basic',
  DESCRIPTION: 'basic',
  ADDRESS: 'address',
  PARKING_INFO: 'address',
  NEIGHBORHOOD_TITLE: 'address',
  NEIGHBORHOOD_DESCRIPTION: 'address',
  BUILDING_OVERVIEW: 'address',
  CARD_TYPE: 'cardLabel',
  CARD_CONTRACT_LABEL: 'cardLabel',
  DISTRICT_LABEL: 'cardLabel',
  PROMOTION_LABEL: 'cardLabel',
  NOTICE_SELECT: 'notice',
  NOTICE_CONFIRM: 'notice',
  SOURCE_NOTICE: 'notice',
  COMMON_AREA_DESCRIPTION: 'common',
};
export const COMPONENT_CATEGORY: Record<Component['kind'], CategoryId> = {
  COMMON_AREA: 'common',
  LOCATION_BULLET: 'location',
  LOCATION_LINE: 'location',
  FLOOR_DIRECTORY: 'floor',
};
export const KIND_TITLE: Record<Component['kind'], string> = {
  COMMON_AREA: '공용공간',
  LOCATION_BULLET: '위치 안내',
  LOCATION_LINE: '교통 노선',
  FLOOR_DIRECTORY: '층 안내',
};
export const PURPOSE_ORDER = Object.keys(purposes);
// 모르는 용도는 추측해 번역하지 않고 코드를 그대로 보여 준다.
export const purposeLabel = (purpose: string) =>
  (purposes as Record<string, string | undefined>)[purpose] ?? purpose;
